/** Состояние беты в `PlayerState.beta` (только `mode: "beta"`). */
import { ChestType } from "../../balance/beta";
import { HeroId, UInt, UnixMs } from "../../common";
import { z } from "zod";

/** Режим игры: `beta` — отдельный баланс, отдельное сохранение. */
export const GameMode = z.enum(["main", "beta"]);
export type GameMode = z.infer<typeof GameMode>;
/** Заголовок запроса, которым клиент выбирает режим (нет — `main`). */
export const MODE_HEADER = "X-Game-Mode";

/** Локация уровня. */
export const BetaLocation = z.string();

/** Где игрок в уровне: уровень `level`, подволна `subwave` из `subwaves`, локация, уровень с боссом. */
export const BetaLevel = z.object({
  level: z.number().int().positive(),
  subwave: z.number().int().positive(),
  subwaves: z.number().int().positive(),
  location: BetaLocation,
  isBossLevel: z.boolean(),
});
export type BetaLevel = z.infer<typeof BetaLevel>;

export const BetaChest = z.object({ id: z.number().int().positive(), type: ChestType });
export type BetaChest = z.infer<typeof BetaChest>;

export const BetaState = z.object({
  /** Кристаллы (вторая валюта). */
  gems: UInt,
  /** Слоты базы: сколько открыто и какой герой стоит в каждом (длина = `slots`). */
  slots: z.number().int().positive(),
  loadout: z.array(HeroId.nullable()),
  /** Осколки по героям. */
  shards: z.partialRecord(HeroId, UInt),
  /** Где игрок в уровне. */
  level: BetaLevel,
  chests: z.array(BetaChest),
  /** Купленные прокрутки колеса (тратятся после бесплатной). */
  spinTokens: UInt,
  wheel: z.object({
    /** Бесплатная прокрутка доступна. */
    freeAvailable: z.boolean(),
    nextFreeAt: UnixMs,
    /** «x2 монет» действует до; `null` — нет. */
    boostUntil: UnixMs.nullable(),
  }),
});
export type BetaState = z.infer<typeof BetaState>;
